const {
  //eslint-disable-next-line
  REACT_APP_BACK_API_KEY,
  REACT_APP_BACK_URL,
} = process.env;

const config = {
  BACK_API_KEY: REACT_APP_BACK_API_KEY as string,
  BACK_URL: REACT_APP_BACK_URL as string,
};

export default config;
